import { ProductName } from '@pypestream/api-services';
import { css, html } from 'lit';
import { state } from 'lit/decorators.js';

import { BaseElement, customElement } from '../../components/base-element';

import '../../components/buttons/icon-button/icon-button.wc';

declare global {
  interface Window {
    Produktly?: {
      openChangelog: (options: { id: number }) => void;
    };
  }
}

const changelogIds: Record<ProductName, number> = {
  [ProductName.Organization]: 709,
  [ProductName.Analytics]: 591,
  [ProductName.ProStudio]: 736,
  [ProductName.AgentAssist]: 704,
};

@customElement('ps-universal-nav-changelog')
export class UniversalNavChangelogWC extends BaseElement {
  static styles = css`
    :host {
      display: contents;
    }
  `;

  @state() private app: ProductName = ProductName.Organization;

  connectedCallback() {
    super.connectedCallback();
    const parentNav = this.closest('ps-universal-nav');
    if (parentNav) {
      this.app =
        (parentNav.getAttribute('app') as ProductName) ??
        ProductName.Organization;
    }
  }

  private handleClick(): void {
    const id = changelogIds[this.app];
    if (!id) {
      // eslint-disable-next-line no-console
      console.warn(
        `[ps-universal-nav-changelog] No changelog ID configured for app "${this.app}".`
      );
      return;
    }
    if (!window.Produktly) {
      // eslint-disable-next-line no-console
      console.warn(
        '[ps-universal-nav-changelog] Produktly is not loaded on this page.'
      );
      return;
    }
    window.Produktly.openChangelog({ id });
  }

  render() {
    return html`
      <ps-icon-button
        name="changelog"
        @click=${() => this.handleClick()}
      ></ps-icon-button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-universal-nav-changelog': UniversalNavChangelogWC;
  }
  enum PSElementTagNameMap {
    'ps-universal-nav-changelog' = 'ps-universal-nav-changelog',
  }
}
